import "./VenueSection.scss";

export const VenueSection = () => {
  return (
  <section id="venue" className="venue-section">
      <div className="venue-card">
        <div className="venue-text">
          <h2>Helyszín</h2>

          <p className="venue-address">
            Etyeki Czímeres Pálinkaház, Sóskúti út
          </p>

          <p>
            A polgári szertartás helyszíne, amely díjmentes
            parkolási lehetőséget biztosít az eseményünk ideje alatt.
          </p>

          <p>
            Az első programpont helyszíne viszont az Etyeki
            Sarlós Boldogasszony-templom, amely körülbelül 10 perc
            sétára található a Czímeres Pálinkaháztól.
          </p>

          <p className="venue-highlight">
            Mivel a két szertartás között feszített tempónk lesz,
            így ha megoldható, javasoljuk még a templomi szertartás
            előtt elfoglalni az esetleges szállást.
          </p>
        </div>

        <div className="venue-image">
          <img
            src="/images/czimeres.jpg"
            alt="Etyeki Czímeres Pálinkaház"
          />
        </div>
      </div>
    </section>
  );
};